import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async create(payload) {
        return await http.post(buildUrlFromLocation("/cf/rechallenges", { campaignId: null }), payload);
    }
};



// WEBPACK FOOTER //
// ./src/services/cfRechallenge.js